import script from "./GmxCustomChart.vue?vue&type=script&setup=true&lang=js"
export * from "./GmxCustomChart.vue?vue&type=script&setup=true&lang=js"

import "./GmxCustomChart.vue?vue&type=style&index=0&id=21de218e&lang=css"

const __exports__ = script;

export default __exports__